<template>
  <error-content :show-btn="showBtn" code="403" desc="Oh~~您没有浏览这个页面的权限~" :src="src"/>
</template>

<script>
import error401 from '@/assets/images/error-page/error-401.svg'
import errorContent from './error-content.vue'
export default {
  name: 'error_401',
  props: {
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  components: {
    errorContent
  },
  data () {
    return {
      src: error401
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/error-page/401.vue